import React from 'react';

import './index.css';

function Footer() {
    return (
        <footer className="footer bg-dark">
            <div className="navbar">
                <div className='navbar-nav'>
                    <span className="subtitulo p-left-20">Novela fantastica_</span>
                </div>
                <div className='navbar-nav p-right-20 autor-wrapper'>
                    <span className="editorial">EL GUARDIAN LITERARIO</span>
                </div>
            </div>
        </footer>
    )
}

export default Footer;